import { Component, OnInit, ViewChild } from '@angular/core';
import { PanelBarComponent, TabStripComponent } from '@progress/kendo-angular-layout';
import { SearchSelectionModel } from '../../models/search-selection';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-right-side-section',
  templateUrl: './right-side-section.component.html',
  styleUrls: ['./right-side-section.component.css']
})
export class RightSideSectionComponent implements OnInit {
  @ViewChild("rightSidePanelBar", { static: false}) panelBar: PanelBarComponent;
  @ViewChild("rightSideTabStrip", { static: false}) tabStrip: TabStripComponent;

  searchSelectionModel: SearchSelectionModel;
 
  constructor(private readonly sharedService: SharedService) { }

  ngOnInit(): void {
    this.sharedService.currentCommonInputSelections.subscribe(data => {
      if (data) {
        this.searchSelectionModel = data;
      }
    });

    this.sharedService.runQuery.subscribe(
      run => {
        if (run !== null && run === true) {
          // collapse all panels on right side
          this.tabStrip.selectTab(0);
        }
      }
    );

    // used to detect when saved query or history query is loaded so that we automagically move to the selections tab
    this.sharedService.activeSavedFilters.subscribe(data => {
      if (data) {
        this.tabStrip.selectTab(0);
      }
    });
  }

}
